
<div>
    <h1 class ="ft-wt categories-page-title">Select a Category</h1>
</div>
<div *ngIf="viewType == 'grid' && categories.length === 0" fxLayout="row wrap">
    <div *ngFor = "let item of array">
        <div class="fb-item" >
            <div class="first-section-wrapper">
                <div class="gravatar">
                <ngx-skeleton-loader
                    appearance="circle"
                    [theme]="{ width: '80px', height: '80px', 'border-radius': '10px' }"
                >
                </ngx-skeleton-loader>
                </div>
                <div class="gravatar-title">
                <div>
                    <ngx-skeleton-loader
                    [theme]="{
                        width: '200px',
                        'border-radius': '0',
                        height: '15px',
                        'margin-bottom': '10px'
                    }"
                    ></ngx-skeleton-loader>
                </div>
                <div>
                    <ngx-skeleton-loader
                    [theme]="{ width: '170px', 'border-radius': '0', height: '15px' }"
                    ></ngx-skeleton-loader>
                </div>
                </div>
            </div>
            <div class="second-section-wrapper">
                <div class="wrapper">
                <ngx-skeleton-loader
                    [theme]="{
                    width: '80%',
                    'border-radius': '0',
                    height: '15px',
                    'margin-bottom': '10px'
                    }"
                ></ngx-skeleton-loader>
                </div>
                <div class="wrapper">
                <ngx-skeleton-loader
                    [theme]="{
                    width: '90%',
                    'border-radius': '0',
                    height: '15px',
                    'margin-bottom': '10px'
                    }"
                ></ngx-skeleton-loader>
                </div>
                <div class="wrapper">
                <ngx-skeleton-loader
                    [theme]="{
                    width: '60%',
                    'border-radius': '0',
                    height: '15px',
                    'margin-bottom': '10px'
                    }"
                ></ngx-skeleton-loader>
                </div>
            </div>
        </div>
    </div>
     
</div>
<ng-container *ngIf="featureTags && !featureTags['sf_all_grison']">
    <div *ngIf="viewType == 'grid'" fxLayout="row wrap"  class="mt-1 products-wrapper">
        <ng-container *ngFor="let category of categories;let e = index;">
            <div class="product-item" fxFlex="100" fxFlex.sm = "25%" [fxFlex.gt-sm]="viewCol" 
                class="col section-ht text-center mb-10" *ngIf="!!category.category_name || !!category.category_url">
                <a *ngIf = "storeDetailsJson['settings']['productFullView'] === true" class="image-link" [routerLink]="['/categories',  category['category_url']]" >
                    <img src="data:," [imgName]="category['category_image']" imgType="categories" alt = "{{category['category_name']}}"
                        class ="max-ht img-fit" [ngStyle]="{'border-radius': storeDetailsJson['settings']['borderRadius']}" 
                        [ngClass] = "{'mat-elevation-z8' : e == mouseOverIndex}" (mouseover)="onMouseOver(e)" 
                        (mouseout)="onMouseOut(e)" imagePreload />
                </a>
                <a *ngIf = "storeDetailsJson['settings']['productFullView'] === false" class="image-link" [routerLink]="['/categories', category['category_url']]"  [id]="(category['category_name'] | lowercase)">
                    <img src="data:," [imgName]="category['category_image']" imgType="categories" alt = "{{category['category_name']}}"
                        class ="max-ht img-fit" [ngStyle]="{'border-radius': storeDetailsJson['settings']['borderRadius']}" 
                        [ngClass] = "{'mat-elevation-z8' : e == mouseOverIndex}" (mouseover)="onMouseOver(e)" 
                        (mouseout)="onMouseOut(e)" imagePreload />
                </a>
                <a *ngIf="viewType == 'grid'" class ="imgStyle" [routerLink]=" ['/categories',  category['category_url']]" >
                    <h4 *ngIf="viewType == 'grid'" 
                        
                        class = "clr-blu text-center">
                        <span [innerHTML]="category['category_name']  | sanitizeHtml" class =  "link-clr wid"></span>&nbsp;
                        <span *ngIf = "storeDetailsJson && storeDetailsJson['settings']['productCountShow'] === true" class ="blk-clr"> ({{category['count']}})</span>
                    </h4>  
                </a>                
                <div class ="subCat pl-10 text-center">
                    <ul  class = "ul-spl">
                        <li *ngFor="let sub of category['sub_list'] | slice:0:3 ;let i = index;">  
                            <a  [routerLink]="['/categories', category['category_url'] , sub['category_url']]"  
                                 class = "link-clr">
                                {{sub['category_name'] | titlecase}}
                            </a> 
                            <span class = "blk-clr">&nbsp;<span *ngIf = "storeDetailsJson && storeDetailsJson['settings']['productCountShow'] === true">({{sub['count']}})</span></span>
                        </li>
                        <li *ngIf = "category['sub_list'].length > 3"> 
                            <a   [routerLink]="['/categories', category['category_url'] ]"  class = "link-clr">
                                All Categories ->
                            </a>
                        </li>
                    </ul>
                </div>
            </div>
        </ng-container>
        <ng-container *ngIf = "categories.length > 0">
            <div class="product-item" fxFlex="100" fxFlex.sm = "25%" [fxFlex.gt-sm]="viewCol" 
            class="col section-ht text-center mb-10" >
            <!-- <a class="image-link" [routerLink]="['/all-products']" > -->
            <a class="image-link" [routerLink]="['/products']" id="allProducts">
                <img src="assets/images/all_products.png"  alt = "All Products"
                    class ="max-ht img-fit" [ngStyle]="{'border-radius': storeDetailsJson['settings']['borderRadius']}" 
                    [ngClass] = "{'mat-elevation-z8' : e == mouseOverIndex}" (mouseover)="onMouseOver(e)" 
                    (mouseout)="onMouseOut(e)"  />
            </a>
            <!-- <a *ngIf="viewType == 'grid'" class ="imgStyle" [routerLink]=" ['/all-products']" > -->
            <a *ngIf="viewType == 'grid'" class ="imgStyle" [routerLink]=" ['/products']" id="allProducts">
                <h4 *ngIf="viewType == 'grid'" 
                    class = "clr-blu text-center">
                    <span  class =  "link-clr wid">All Products</span>&nbsp;
                </h4>  
            </a>    
            </div>
        </ng-container>
    </div>
</ng-container>
<ng-container *ngIf="featureTags && featureTags['sf_all_grison']">
    <div *ngIf="viewType == 'grid' && categories" fxLayout="row wrap"  class="mt-1 products-wrapper">
        <ng-container *ngIf="featureTags && featureTags['ftag_sf_previously_ordered_products']">
        <ng-container *ngFor="let category of filteredCategories;let e = index;">
            <div class="product-item" fxFlex="100" fxFlex.sm = "25%" [fxFlex.gt-sm]="viewCol" 
                class="col section-ht text-center mb-10" *ngIf="(!!category.category_name || !!category.category_url) && category.category_name !== 'ALL'">
                <a *ngIf = "storeDetailsJson['settings']['productFullView'] === true" class="image-link" [routerLink]="['/categories',  category['category_url']]" >
                    <img src="data:," [imgName]="category['category_image']" imgType="categories" alt = "{{category['category_name']}}"
                        class ="max-ht img-fit" [ngStyle]="{'border-radius': storeDetailsJson['settings']['borderRadius']}" 
                        [ngClass] = "{'mat-elevation-z8' : e == mouseOverIndex}" (mouseover)="onMouseOver(e)" 
                        (mouseout)="onMouseOut(e)" imagePreload />
                </a>
                <a *ngIf = "storeDetailsJson['settings']['productFullView'] === false" class="image-link" [routerLink]="['/categories', category['category_url']]"  [id]="(category['category_name'] | lowercase)">
                    <img src="data:," [imgName]="category['category_image']" imgType="categories" alt = "{{category['category_name']}}"
                        class ="max-ht img-fit" [ngStyle]="{'border-radius': storeDetailsJson['settings']['borderRadius']}" 
                        [ngClass] = "{'mat-elevation-z8' : e == mouseOverIndex}" (mouseover)="onMouseOver(e)" 
                        (mouseout)="onMouseOut(e)" imagePreload />
                </a>
                <a *ngIf="viewType == 'grid'" class ="imgStyle" [routerLink]=" ['/categories',  category['category_url']]" >
                    <h4 *ngIf="viewType == 'grid'" 
                        
                        class = "clr-blu text-center">
                        <span [innerHTML]="category['category_name']  | sanitizeHtml" class =  "link-clr wid"></span>&nbsp;
                        <span *ngIf = "storeDetailsJson && storeDetailsJson['settings']['productCountShow'] === true" class ="blk-clr"> ({{category['count']}})</span>
                    </h4>  
                </a>                
                <div class ="subCat pl-10 text-center">
                    <ul  class = "ul-spl">
                        <li *ngFor="let sub of category['sub_list'] | slice:0:3 ;let i = index;">  
                            <a  [routerLink]="['/categories', category['category_url'] , sub['category_url']]"  
                                 class = "link-clr">
                                {{sub['category_name'] | titlecase}}
                            </a> 
                            <span class = "blk-clr">&nbsp;<span *ngIf = "storeDetailsJson && storeDetailsJson['settings']['productCountShow'] === true">({{sub['count']}})</span></span>
                        </li>
                        <li *ngIf = "category['sub_list'].length > 3"> 
                            <a   [routerLink]="['/categories', category['category_url'] ]"  class = "link-clr">
                                All Categories ->
                            </a>
                        </li>
                    </ul>
                </div>
            </div>
        </ng-container>
        </ng-container>
        <ng-container *ngIf="featureTags && !featureTags['ftag_sf_previously_ordered_products']">
        <ng-container *ngFor="let category of categories;let e = index;">
            <div class="product-item" fxFlex="100" fxFlex.sm = "25%" [fxFlex.gt-sm]="viewCol" 
                class="col section-ht text-center mb-10" *ngIf="(!!category.category_name || !!category.category_url) && category.category_name !== 'ALL'">
                <a *ngIf = "storeDetailsJson['settings']['productFullView'] === true" class="image-link" [routerLink]="['/categories',  category['category_url']]" >
                    <img src="data:," [imgName]="category['category_image']" imgType="categories" alt = "{{category['category_name']}}"
                        class ="max-ht img-fit" [ngStyle]="{'border-radius': storeDetailsJson['settings']['borderRadius']}" 
                        [ngClass] = "{'mat-elevation-z8' : e == mouseOverIndex}" (mouseover)="onMouseOver(e)" 
                        (mouseout)="onMouseOut(e)" imagePreload />
                </a>
                <a *ngIf = "storeDetailsJson['settings']['productFullView'] === false" class="image-link" [routerLink]="['/categories', category['category_url']]"  [id]="(category['category_name'] | lowercase)">
                    <img src="data:," [imgName]="category['category_image']" imgType="categories" alt = "{{category['category_name']}}"
                        class ="max-ht img-fit" [ngStyle]="{'border-radius': storeDetailsJson['settings']['borderRadius']}" 
                        [ngClass] = "{'mat-elevation-z8' : e == mouseOverIndex}" (mouseover)="onMouseOver(e)" 
                        (mouseout)="onMouseOut(e)" imagePreload />
                </a>
                <a *ngIf="viewType == 'grid'" class ="imgStyle" [routerLink]=" ['/categories',  category['category_url']]" >
                    <h4 *ngIf="viewType == 'grid'" 
                        
                        class = "clr-blu text-center">
                        <span [innerHTML]="category['category_name']  | sanitizeHtml" class =  "link-clr wid"></span>&nbsp;
                        <span *ngIf = "storeDetailsJson && storeDetailsJson['settings']['productCountShow'] === true" class ="blk-clr"> ({{category['count']}})</span>
                    </h4>  
                </a>                
                <div class ="subCat pl-10 text-center">
                    <ul  class = "ul-spl">
                        <li *ngFor="let sub of category['sub_list'] | slice:0:3 ;let i = index;">  
                            <a  [routerLink]="['/categories', category['category_url'] , sub['category_url']]"  
                                 class = "link-clr">
                                {{sub['category_name'] | titlecase}}
                            </a> 
                            <span class = "blk-clr">&nbsp;<span *ngIf = "storeDetailsJson && storeDetailsJson['settings']['productCountShow'] === true">({{sub['count']}})</span></span>
                        </li>
                        <li *ngIf = "category['sub_list'].length > 3"> 
                            <a   [routerLink]="['/categories', category['category_url'] ]"  class = "link-clr">
                                All Categories ->
                            </a>
                        </li>
                    </ul>
                </div>
            </div>
         </ng-container>   
        </ng-container>
        <ng-container *ngIf = "categories.length > 0">
            <div class="product-item" fxFlex="100" fxFlex.sm = "25%" [fxFlex.gt-sm]="viewCol" 
            class="col section-ht text-center mb-10" >
            <!-- <a class="image-link" [routerLink]="['/all-products']" > -->
            <a class="image-link" [routerLink]="['/products']" id="allProducts">
                <img src="assets/images/all_products.png"  alt = "All Products"
                    class ="max-ht img-fit" [ngStyle]="{'border-radius': storeDetailsJson['settings']['borderRadius']}" 
                    [ngClass] = "{'mat-elevation-z8' : e == mouseOverIndex}" (mouseover)="onMouseOver(e)" 
                    (mouseout)="onMouseOut(e)"  />
            </a>
            <!-- <a *ngIf="viewType == 'grid'" class ="imgStyle" [routerLink]=" ['/all-products']" > -->
            <a *ngIf="viewType == 'grid'" class ="imgStyle" [routerLink]=" ['/products']" id="allProducts">
                <h4 *ngIf="viewType == 'grid'" 
                    class = "clr-blu text-center">
                    <span  class =  "link-clr wid">All Products</span>&nbsp;
                </h4>  
            </a>    
            </div>
        </ng-container>
    </div>
</ng-container>

